import React from 'react';
import { Field } from 'redux-form';
import { Col, FormGroup, Image, Row } from 'react-bootstrap';
import { get } from 'lodash';
import parseFloatValue from '../../../../../../../../helpers/parseFloatValue';
import { addValidator, numericality } from 'redux-form-validators';
import { InfoLabel } from '../../../../../../../../common/components';
import './InsurerCommissionTable.scss';
import { CheckboxInput } from '../../../../../../../../common/components/PublicCheckbox/PublicCheckbox';
import { FormGroupInput } from '../../../../../../../../common/form/components/components';

const isNumeric = numericality({ message: 'Must be a number', allowBlank: true });
const rateValidator = addValidator({
  validator: function(options, value, allValues) {
    if (value && value > 0 && !get(allValues, `${options.fieldName}.enabled`, false)) {
      return {
        id: 'form.errors.custom',
        defaultMessage: 'Must be enabled',
      };
    }
  },
});
addValidator({
  validator: function(options, value, allValues) {
    if (get(allValues, `${options.fieldName}.enabled`) && !value) {
      return {
        id: 'form.errors.custom',
        defaultMessage: 'Rate must be set if enabled',
      };
    }
  },
});
const requiredIfEnabled = addValidator({
  validator: function(options, value, allValues) {
    if (get(allValues, `${options.fieldName}.enabled`) && !value) {
      return {
        id: 'form.errors.custom',
        defaultMessage: 'This field is required if commission is enabled',
      };
    }
  },
});
const isValidCommission = addValidator({
  validator: function(options, value) {
    if (value && parseFloatValue(value) > options.maxCommission) {
      return {
        id: 'form.errors.custom',
        defaultMessage: 'Must be under Max Brokerage',
      };
    }
  },
});

const Label = ({ logo, name }) => {
  if (logo) {
    return <Image className={'insurer-logo'} fluid src={logo} alt={name} />;
  }
  return <span className={'insurer-logo'}>{name}</span>;
};

const BrokerTable = ({ input }) => {
  return (
    <>
      <Row>
        <Col sm={2}>
          <Label logo={input.value.logo} name={input.value.name} />
        </Col>
        <Col sm={1}>
          <div className={'enable-checkbox'}>
            <Field
              name={`${input.name}.enabled`}
              component={CheckboxInput}
              colour={'#CF2631'}
            />
          </div>
        </Col>
        <Col sm={2}>
          <Field
            name={`${input.name}.rate`}
            addOnAfter={'%'}
            component={FormGroupInput}
            cleaveOptions={{ numeral: true }}
            normalize={parseFloatValue}
            validate={[
              rateValidator({ fieldName: input.name }),
              requiredIfEnabled({ fieldName: input.name }),
              isNumeric,
              isValidCommission({
                maxCommission: input.value.max_commission || 100,
              }),
            ]}
          />
        </Col>
        <Col sm={2}>
          <FormGroup>
            <Col sm={12}>
              <InfoLabel>
                {input.value.max_commission
                  ? parseFloat(input.value.max_commission).toFixed(1) + '%'
                  : ''}
              </InfoLabel>
            </Col>
          </FormGroup>
        </Col>
        <Col sm={2}>
          <Field
            name={`data.attributes.total_commission_overrides.${input.value.insurer}`}
            addOnAfter={'%'}
            component={FormGroupInput}
            cleaveOptions={{ numeral: true }}
            normalize={parseFloatValue}
          />
        </Col>
      </Row>
    </>
  );
};

const InsurerCommissionTable = ({ fields, availableProducts, productName }) => {
  return (
    <div className={'insurer-commission-table'}>
      <h2 className={'product-title '}>{productName}</h2>

      <>
        <div className={'table-header'}>
          <Row>
            <Col xs={2}>
              <p>Brand</p>
            </Col>
            <Col xs={1}>
              <p>Enabled</p>
            </Col>
            <Col xs={2}>
              <p>Brokerage</p>
            </Col>
            <Col xs={2}>
              <p>Max Brokerage</p>
            </Col>
            <Col xs={2}>
              <p>Override</p>
            </Col>
          </Row>
        </div>
        {fields.map((key) => (
          <div className={'broker-table'} key={key}>
            <Field
              name={key}
              component={BrokerTable}
              availableProducts={availableProducts}
            />
          </div>
        ))}
      </>
    </div>
  );
};

export default InsurerCommissionTable;
